import axios from 'axios';
import notify, { MESSAGES } from '../../../utils/notify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';
import useAsyncAction from '../../../Components/Hooks/useAsyncAction';
import { NEGOTIATION_HANDOFF_STORAGE_PREFIX } from '../../../shared/offer-domain/negotiation';

// Old builds kept the draft in sessionStorage; BE is now the source of truth.
const clearLegacyHandoffDrafts = () => {
  try {
    Object.keys(sessionStorage)
      .filter(key => key.startsWith(NEGOTIATION_HANDOFF_STORAGE_PREFIX))
      .forEach(key => sessionStorage.removeItem(key));
  } catch {
    // storage unavailable — nothing to clear
  }
};

/** PUT /negotiation/selection — upsert the package from the TE wizard draft. */
const useSaveNegotiationSelection = () => {
  const [saveSelection, isLoading] = useAsyncAction(
    async ({ draft, onSuccess }) => {
      if (!draft?.procurementId) {
        notify.error(
          'Procurement ID is missing. Refresh the page and try again.'
        );
        return false;
      }

      const token = getAuthToken();
      if (!token) {
        notify.error(MESSAGES.authRequired);
        return false;
      }

      try {
        const response = await axios.put(
          `${api.API_URL}/negotiation/selection`,
          draft,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        clearLegacyHandoffDrafts();
        notify.success('Pilihan Negotiation berhasil disimpan.');
        onSuccess?.(response?.data?.data ?? null);
        return true;
      } catch (err) {
        notify.apiError(err, 'save negotiation selection');
        return false;
      }
    }
  );

  return { saveSelection, isLoading };
};

export default useSaveNegotiationSelection;
